module.exports = __webpack_public_path__ + "img/camper.ca5d76cc.svg";